const GMAPS_API_KEY = 'AIzaSyB7W7vkVaQRKwq3UMR5gAKRVghbooEajJ0';
const GMAPS_UD_CALLBACK = 'gmapsCallback';

let gmapsInitialized = !!window.google;
let gmapsResolveInitPromise;
let gmapsRejectInitPromise;
// This promise handles the initialization
// status of the google maps script.
// source: https://markus.oberlehner.net/blog/using-the-google-maps-api-with-vue/
const gmapsInitPromise = new Promise((resolve, reject) => {
  gmapsResolveInitPromise = resolve;
  gmapsRejectInitPromise = reject;
});

export default function init() {
    // If Google Maps already is initialized
    // the `initPromise` should get resolved
    // eventually.
    if (gmapsInitialized) return gmapsInitPromise;

    gmapsInitialized = true;
    // The callback function is called by
    // the Google Maps script if it is
    // successfully loaded.
    window[GMAPS_UD_CALLBACK] = () => gmapsResolveInitPromise(window.google);

    // We inject a new script tag into
    // the `<head>` of our HTML to load
    // the Google Maps script.
    const script = document.createElement('script');
    script.async = true;
    script.defer = true;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GMAPS_API_KEY}&callback=${GMAPS_UD_CALLBACK}`;
    script.onerror = gmapsRejectInitPromise;
    document.querySelector('head').appendChild(script);

    return gmapsInitPromise;
}